import ProjectCalendarGateway from "./project-calendar-gateway";
import ProjectCalendar from "./project-calendar";
import ClientLike from "../client-like";
import parseDate from "@/helpers/parseDate";
import { Project } from "./project";
import { Task } from "./task";

export interface SearchProjectCalendarQuery {
  status?: string | number;
  staff?: string;
  company?: string;
  role?: string;
  companyList?: string;
}

export default class ProjectCalendarApi implements ProjectCalendarGateway {
  public constructor(private client: ClientLike) {}

  public async all(
    query: SearchProjectCalendarQuery = {}
  ): Promise<ProjectCalendar[]> {
    const data = await this.client.get("get_project_calendar.php", {
      status: query.status,
      companyType: query.company,
      staffId: query.staff,
      serviceRoleId: query.role,
      companyId: query.companyList
    });
    return data.projectCalendar.map(toProjectCalendar);
  }
}

function toProjectCalendar(data: any) {
  // TODO: APIのバグでprojectが重複するので対応してる
  const projects = data.projects
    .reduce((ps: { projectId: number }[], p: { projectId: number }) => {
      return ps.some(q => p.projectId === q.projectId) ? ps : ps.concat([p]);
    }, [])
    .map(toProject);

  return {
    user: data.user,
    projects
  };
}

function toProject(data: any): Project {
  return {
    id: data.projectId,
    name: data.name,
    start: parseDate(data.start),
    end: parseDate(data.end),
    tasks: data.tasks.map(toTask)
  };
}

function toTask(data: any): Task {
  return {
    id: Number(data.taskId),
    name: data.name,
    start: new Date(data.start),
    end: new Date(data.end)
  };
}
